import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Col, Row } from 'reactstrap';

import AsyncMultiSelectField from '../../../../_components/select-components/async-multi-select';
import AsyncSelectField from '../../../../_components/select-components/async-select';

import useLookups from './lookups';

export default function DiagnosisCodes() {
  const { icdTenLookup } = useLookups();

  return (
    <>
      <Row>
        <Col lg={6}>
          <AsyncSelectField
            required
            label="Primary Diagnosis"
            name="primaryDiagnosis"
            loadOptions={icdTenLookup}
            placeholder="Enter a partial description or code and select an option"
            noResultsMessage={(input) =>
              input?.trim()?.match(/^[a-zA-Z0-9]{5}$/)?.length ? (
                <div className="text-danger d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    size="sm"
                    className="me-1"
                  />
                  <small role="alert" className="fw-bold">
                    The diagnosis code {input} is not available
                  </small>
                </div>
              ) : (
                <div role="alert">No results found</div>
              )
            }
          />
        </Col>
        <Col lg={6}>
          <AsyncMultiSelectField
            label="Secondary Diagnosis"
            name="secondaryDiagnosis"
            loadOptions={icdTenLookup}
            placeholder="Enter a partial description or code and select an option"
            noResultsMessage={(input) =>
              input?.trim()?.match(/^[a-zA-Z0-9]{5}$/)?.length ? (
                <div className="text-danger d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    size="sm"
                    className="me-1"
                  />
                  <small role="alert" className="fw-bold">
                    The diagnosis code {input} is not available
                  </small>
                </div>
              ) : (
                <div role="alert">No results found</div>
              )
            }
          />
        </Col>
      </Row>
    </>
  );
}
